<template>
    <div
        class="tw-w-full tw-p-0 tw-m-0 tw-bg-gray-100"
        style="height: 100%; min-height: 200px"
    >
        <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
            <b-tabs card fill>
                <!-- <b-tab title="Baseline"> -->
                <b-tab
                    v-for="(tab, key) in data.clearanceDose"
                    :title="key"
                    :key="key"
                    :active="key === defaultSelected"
                >
                    <b-container fluid>
                        <b-row>
                            <b-col md="12" lg="6">
                                <h6 class="tw-font-bolder text-center">
                                    Clearance
                                </h6>
                                <b-list-group>
                                    <b-list-group-item
                                        variant="primary"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Started
                                        <b-badge variant="primary" pill>{{
                                            data.clearanceDose[key][0]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="success"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Completed
                                        <b-badge variant="primary" pill>{{
                                            data.clearanceDose[key][1]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="warning"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        In Progress
                                        <b-badge variant="primary" pill>{{
                                            data.clearanceDose[key][2]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="danger"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Overdue
                                        <b-badge variant="primary" pill>{{
                                            data.clearanceDose[key][3]
                                        }}</b-badge>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col md="12" lg="6">
                                <h6 class="tw-font-bolder text-center tw-mt-1">
                                    Malaria Treatment
                                </h6>
                                <b-list-group>
                                    <b-list-group-item
                                        variant="primary"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Started
                                        <b-badge variant="primary" pill>{{
                                            data.malariaTreatment[key][0]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="success"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Completed
                                        <b-badge variant="primary" pill>{{
                                            data.malariaTreatment[key][1]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="warning"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        In Progress
                                        <b-badge variant="primary" pill>{{
                                            data.malariaTreatment[key][2]
                                        }}</b-badge>
                                    </b-list-group-item>
                                    <b-list-group-item
                                        variant="danger"
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        Overdue
                                        <b-badge variant="primary" pill>{{
                                            data.malariaTreatment[key][3]
                                        }}</b-badge>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="text-right tw-mt-3">
                                    <b-button
                                        :to="{
                                            name: 'table-clearance-malaria',
                                            params: { view: 'clearance-dose' },
                                        }"
                                        variant="outline-secondary"
                                        >More</b-button
                                    >
                                </div>
                            </b-col>
                            <b-col>
                                <div class="text-right tw-mt-3">
                                    <b-button
                                        :to="{
                                            name: 'table-clearance-malaria',
                                            params: {
                                                view: 'malaria-treatment',
                                            },
                                        }"
                                        variant="outline-secondary"
                                        >More</b-button
                                    >
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-tab>
            </b-tabs>

            <div class="tw-mt-auto tw-flex tw-justify-end">
                <info-popover>
                    <template v-slot:title>
                        Clearance Dose / Malaria Treatment progress
                    </template>

                    <h5>Started</h5>
                    <p>
                        How many subjects have started clearance dose or malaria
                        treatment.
                    </p>

                    <h5>Completed</h5>
                    <p>
                        How many subjects have completed clearance dose or
                        malaria treatment
                    </p>

                    <h5>In Progress</h5>
                    <p>
                        How many subjects have not completed clearance dose or
                        malaria treatment
                    </p>

                    <h5>Overdue</h5>
                    <p>Overdue = Started - Completed - In Progress</p>
                </info-popover>
            </div>
        </b-card>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

export default {
    mixins: [],
    components: {},
    props: {},
    data: function () {
        return {
            data: {
                clearanceDose: {},
                malariaTreatment: {},
            },
            defaultSelected: "Cohort 2"
        };
    },
    computed: {},
    created: function () {},
    mounted: function () {
        this.get();
    },
    methods: {
        get: async function () {
            const that = this;

            that.data.malariaTreatment = await HTTP.get(
                "/kenya/metrics/clearance-malaria"
            ).then((response) => {
                return response.data;
            });

            that.data.clearanceDose = await HTTP.get(
                "/kenya/metrics/clearance-malaria?view=clearance"
            ).then((response) => {
                return response.data;
            });
        }
    },
};
</script>

<style></style>
